import {Injectable, Output, EventEmitter } from '@angular/core';
import {persistState, Store, StoreConfig} from '@datorama/akita';
import * as localForage from 'localforage';
import { Tokens } from '@app/services/auth/token.model';
import { Logger } from '@app/services/logger/logger.service';
import { decodeJWT } from '@app/utils';


const authStore = localForage.createInstance({
  name: 'patientLynk',
  storeName: 'auth_store'
});

persistState({ include: ['auth'], storage: authStore });

export interface AuthState {
   access: string;
   refresh: string;
   dbs: string[];
}

export function createInitialState(): AuthState {
  return {
    access: '',
    refresh: '',
    dbs: []
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({
  name: 'auth',
  resettable: true,
  cache: {
    ttl: 2880000 // 4h
  }
})
export class AuthStore extends Store<AuthState> {

  constructor() {
    super(createInitialState());
  }

  setAll({ access, refresh }: Tokens) {
    const { databases = [] } = decodeJWT(access);

    let allDatabases = databases;
    if (!Array.isArray(databases)) {
      allDatabases = Object.values(databases).flat() as string[];
      allDatabases = Array.from(new Set(allDatabases)); // remove duplicates
    }

    allDatabases = allDatabases.filter(db => db != "default")
    this.update(currentState => ({ ...currentState, access, refresh, dbs: allDatabases }));
  }

  reset() {
    this.update(currentState => ({ ...currentState, access: '', refresh: '' }));
  }

  storeDatabases(db){
    const { databases = [] } = db;
    let allDatabases = databases;
    if (!Array.isArray(databases)) {
      allDatabases = Object.values(databases).flat() as string[];
      allDatabases = Array.from(new Set(allDatabases)); // remove duplicates
    }

    allDatabases = allDatabases.filter(db => db != "default")
    this.update(currentState => ({...currentState, dbs: allDatabases }));
  };

  akitaPreUpdate(prevState, nextState) {
    if (nextState.dbs.length > prevState.dbs.length) {
      const newDBs = nextState.dbs.find(db => !prevState.dbs.includes(db)).toUpperCase();

      //Fallback to make sure its array
      Logger.banner({
        translate: 'insuranceConnection',
        translateParams: newDBs,
        type: 'info',
        persist: true,
        close: true
      });
    }

    return nextState;
  }
}
